var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BgImage',{staticClass:"circle",attrs:{"image":"circle"}},[_c('BCXMarkdown',{staticClass:"centered-block bc-freelancer-welcome",attrs:{"text":_vm.tl(_vm.$t('landingpage-freelancer.intro'), true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }